import { types } from "react-bricks/frontend";
import websitePage from "./website";
import landingPage from "./landing";

const pageTypes: types.IPageType[] = [websitePage, landingPage];

export default pageTypes;
